import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { UserApiCommunityOfDoctorReaderRepository } from './domain/UserApiCommunityOfDoctorReader'
import { SpringPaginationResult } from './pagination'

import {
  CommentOfDoctor,
  DocumentOfDoctor,
  RequestBodyOfGetCommentsOfDoctor,
  RequestBodyOfGetDocumentsOfDoctor,
} from '../../contracts/community/communityOfDoctor'

export class UserApiCommunityOfDoctorReader implements UserApiCommunityOfDoctorReaderRepository {
  private axios: AxiosInstance

  constructor({ axios }: { axios: AxiosInstance }) {
    this.axios = axios
  }

  getDocuments = async (body: RequestBodyOfGetDocumentsOfDoctor): Promise<SpringPaginationResult<DocumentOfDoctor>> => {
    const config: AxiosRequestConfig = {
      url: '/community/queries/get-doctor-community/process',
      method: 'POST',
      data: body,
    }

    const { data } = await this.axios.request<SpringPaginationResult<DocumentOfDoctor>>(config)

    return data
  }

  getComments = async (body: RequestBodyOfGetCommentsOfDoctor): Promise<SpringPaginationResult<CommentOfDoctor>> => {
    const config: AxiosRequestConfig = {
      url: '/community/queries/get-doctor-comment/process',
      method: 'POST',
      data: body,
    }

    const { data } = await this.axios.request<SpringPaginationResult<CommentOfDoctor>>(config)

    return data
  }
}
